import {
  Box,
  Tab,
  Tabs
} from '@mui/material';
import React, { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

type MutlitabOption = {
  value: number;
  label: string;
  tab: ReactNode;

};

export type MultitabOptions = MutlitabOption[];

export type ActivityDetailMultitabProps = {
  tabArray: MultitabOptions;
};

export const FC = (props: ActivityDetailMultitabProps) => {
  const [
    searchParams,
    setSearchParams
  ] = useSearchParams({
    n: '0'
  });
  const activeTab = Number(searchParams.get('n') ?? 0);

  const handleTabChange = (e: React.SyntheticEvent, tabValue: number) => {
    setSearchParams({
      n: tabValue.toString()
    });
  };

  return (
    <Box
      flex='1 1 auto'
    >
      <Box
        display='flex'
        height='100%'

        columnGap='2rem'
        justifyContent='space-between'
        alignItems='flex-end'
      >
        <Box
          borderBottom='1px solid #D1D3D4'
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
          >
            {
              props.tabArray.map((tab, i) => (
                <Tab key={i} value={tab.value} label={tab.label} />
              ))
            }
          </Tabs>
        </Box>

      </Box>

      {props.tabArray.map((tab, i) => (
        <Box
          key={`tab-${i}`}
          role='tabpanel'
          hidden={activeTab !== tab.value}
        >
          {props.tabArray[i].tab}
        </Box>
      ))}

    </Box>

  );
};
